export const PERCENT = 100;
export const THOUSAND = 1e3;
export const MILLION = 1e6;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const MS_PER_MINUTE = 60_000;
export const MS_PER_DAY = 86_400_000;
export const DAYS_PER_WEEK = 7;
